import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var WidgetConfig = require('lib/widgets/WidgetsConfig')

@connect(
  (state, props) => ({
  }),

  (dispatch, props) => ({
    populateData: () => {
      // load writing data
    }
  })
)

@providePopulateData()
class WritingWidget extends React.Component {
  constructor(props) {
    super();
    autobind(this);
  }

  isStudentDash() {
    return this.props.user.role == WidgetConfig.STUDENT_ROLE
  }

  // handles expansion of component
  onClick(item) {
    console.log(item)
    // show appropriate component based on widget item
  }

  buildWidgetItemLink(digest, itemConfig, item) {
    var { link } = itemConfig
    var { user } = this.props

    // build link object  for widget item
    // REPLACE THIS SECTION WHEN //
    // WE CAN EXPAND COMPONENTS //
    if (this.isStudentDash()) {
      return {
        text: link.text,
        location: WidgetConfig.buildStudentDataLink(user.id, link.filters, link.subject, digest)
      }
    }
    /////////////////////////////
    else if (link.expand_component) {
      return {
        text: link.text,
        expand_component: true,
        location: this.onClick.bind(this, item)
      }
    } else {
      return link
    }
  }

  renderWidgetItems() {
    return WidgetConfig.renderWidgetItems(this.props, WidgetConfig.WRITING_WIDGET, this.buildWidgetItemLink, this.props.showEmptyState)
  }

  renderWidgetTitle() {
    return WidgetConfig.renderWidgetTitle(WidgetConfig.WRITING_WIDGET)
  }

  render() {
    return (
      <div className="widgetItemsContainer writingWidget">
        {this.renderWidgetTitle()}
        {this.renderWidgetItems()}
      </div>
    )
  }
};

WritingWidget.WrappedComponent.propTypes = PageStrictPropTypes({
  // @connect handlers
  populateData: PropTypes.func,
  selectStudentList: PropTypes.func,
  selectWidgetDigests: PropTypes.func,

  user: PropTypes.object,
  periodWidgetDigests: PropTypes.array,
  currentWidgetDigests: PropTypes.array,
  compWidgetDigests: PropTypes.array,
  yearlyWidgetDigests: PropTypes.array,
  compSize: PropTypes.number,
  compScope: PropTypes.string,
  showEmptyState: PropTypes.bool
});

module.exports = WritingWidget;


// WEBPACK FOOTER //
// ./modules/components/data/widgets/WritingWidget.js